/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetWithManufacturer
 */
export interface SetWithManufacturer {
    /**
     * Eindeutige Set-ID
     * @type {any}
     * @memberof SetWithManufacturer
     */
    id: any | null;
    /**
     * Name des Sets
     * @type {any}
     * @memberof SetWithManufacturer
     */
    name: any | null;
    /**
     * Set-Nummer
     * @type {any}
     * @memberof SetWithManufacturer
     */
    setNumber: any | null;
    /**
     * Datum der Analyse
     * @type {any}
     * @memberof SetWithManufacturer
     */
    analyzedDate: any | null;
    /**
     * Gesamtzahl der Steine
     * @type {any}
     * @memberof SetWithManufacturer
     */
    totalBricks: any | null;
    /**
     * Anzahl geschützter Steine oder "ANALYZING" wenn noch nicht analysiert
     * @type {any}
     * @memberof SetWithManufacturer
     */
    protectedBricks: any | null;
    /**
     * Liste der geschützten Teilenummern
     * @type {any}
     * @memberof SetWithManufacturer
     */
    protectedBricksList?: any | null;
    /**
     * Anzahl ungeschützter Steine oder "ANALYZING" wenn noch nicht analysiert
     * @type {any}
     * @memberof SetWithManufacturer
     */
    unprotectedBricks: any | null;
    /**
     * Detaillierte Stückliste (bei ANALYZING nur erste 3 Einträge)
     * @type {any}
     * @memberof SetWithManufacturer
     */
    partsList?: any | null;
    /**
     * Gesamtanzahl der Parts in der Stückliste
     * @type {any}
     * @memberof SetWithManufacturer
     */
    totalPartsCount?: any | null;
    /**
     * Aktueller Analyse-Typ des Sets (falls bereits analysiert)
     * @type {any}
     * @memberof SetWithManufacturer
     */
    analyzeType?: SetWithManufacturerAnalyzeTypeEnum | null;
    /**
     * Name des Herstellers
     * @type {string}
     * @memberof SetWithManufacturer
     */
    manufacturerName: string;
    /**
     * Logo-Buchstabe
     * @type {string}
     * @memberof SetWithManufacturer
     */
    manufacturerLogo: string;
    /**
     * Status der Analyse (ANALYZING wenn noch nicht analysiert, COMPLETED wenn History-Eintrag vorhanden)
     * @type {string}
     * @memberof SetWithManufacturer
     */
    analysisStatus: SetWithManufacturerAnalysisStatusEnum;
}


/**
 * @export
 */
export const SetWithManufacturerAnalyzeTypeEnum = {
    Simple: 'SIMPLE',
    Protected: 'PROTECTED',
    All: 'ALL',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type SetWithManufacturerAnalyzeTypeEnum = typeof SetWithManufacturerAnalyzeTypeEnum[keyof typeof SetWithManufacturerAnalyzeTypeEnum];

/**
 * @export
 */
export const SetWithManufacturerAnalysisStatusEnum = {
    Analyzing: 'ANALYZING',
    Completed: 'COMPLETED',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type SetWithManufacturerAnalysisStatusEnum = typeof SetWithManufacturerAnalysisStatusEnum[keyof typeof SetWithManufacturerAnalysisStatusEnum];


/**
 * Check if a given object implements the SetWithManufacturer interface.
 */
export function instanceOfSetWithManufacturer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "setNumber" in value;
    isInstance = isInstance && "analyzedDate" in value;
    isInstance = isInstance && "totalBricks" in value;
    isInstance = isInstance && "protectedBricks" in value;
    isInstance = isInstance && "unprotectedBricks" in value;
    isInstance = isInstance && "manufacturerName" in value;
    isInstance = isInstance && "manufacturerLogo" in value;
    isInstance = isInstance && "analysisStatus" in value;

    return isInstance;
}

export function SetWithManufacturerFromJSON(json: any): SetWithManufacturer {
    return SetWithManufacturerFromJSONTyped(json, false);
}

export function SetWithManufacturerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetWithManufacturer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'setNumber': json['setNumber'],
        'analyzedDate': json['analyzedDate'],
        'totalBricks': json['totalBricks'],
        'protectedBricks': json['protectedBricks'],
        'protectedBricksList': !exists(json, 'protectedBricksList') ? undefined : json['protectedBricksList'],
        'unprotectedBricks': json['unprotectedBricks'],
        'partsList': !exists(json, 'partsList') ? undefined : json['partsList'],
        'totalPartsCount': !exists(json, 'totalPartsCount') ? undefined : json['totalPartsCount'],
        'analyzeType': !exists(json, 'analyzeType') ? undefined : json['analyzeType'],
        'manufacturerName': json['manufacturerName'],
        'manufacturerLogo': json['manufacturerLogo'],
        'analysisStatus': json['analysisStatus'],
    };
}

export function SetWithManufacturerToJSON(value?: SetWithManufacturer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'setNumber': value.setNumber,
        'analyzedDate': value.analyzedDate,
        'totalBricks': value.totalBricks,
        'protectedBricks': value.protectedBricks,
        'protectedBricksList': value.protectedBricksList,
        'unprotectedBricks': value.unprotectedBricks,
        'partsList': value.partsList,
        'totalPartsCount': value.totalPartsCount,
        'analyzeType': value.analyzeType,
        'manufacturerName': value.manufacturerName,
        'manufacturerLogo': value.manufacturerLogo,
        'analysisStatus': value.analysisStatus,
    };
}

